import { type FC } from 'react';

import { Outlet } from 'react-router-dom';

import { SandboxProvider } from '@/providers';

export const GameLayout: FC = () => {
  return (
    <SandboxProvider>
      <Outlet />
    </SandboxProvider>
  );
};
